import { Link } from "react-router-dom";
import * as paths from "../../../constants/paths";
import ImageControl from "../../common/ImageControl";
import { useState } from "react";

export default function TopBlock({ company }) {
  //   const { sponsorType } = company;
  //   const sponsorConfig = {
  //     Active: {
  //       label: "Sponsored",
  //       icon: paths.SITE_BASE_URL + "/images/icon_mini_star.png",
  //       className: "active",
  //     },
  //     Inactive: {
  //       label: "Paused",
  //       icon: paths.SITE_BASE_URL + "/images/icon_mini_pause.png",
  //       className: "inactive",
  //     },
  //   };
  // Social media share URLs
  const [showShare, setShowShare] = useState(false);

  // Company page URL (you can adjust this)
  const companyUrl = window.location.href;
  const socialLinks = [
    {
      name: "Facebook",
      icon: paths.SITE_BASE_URL + "/images/icons8-facebook-60.png",
      url: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(companyUrl)}`,
    },
    {
      name: "Twitter",
      icon: paths.SITE_BASE_URL + "/images/icons8-twitter-60.png",
      url: `https://x.com//intent/tweet?url=${encodeURIComponent(companyUrl)}&text=${encodeURIComponent(company?.name)}`,
    },
    {
      name: "LinkedIn",
      icon: paths.SITE_BASE_URL + "/images/icons8-linkedin-60.png",
      url: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(companyUrl)}`,
    },
  ];

  return (
    <div className="top_block">
      <div className="contain">
        <div className="inner">
          <div className="icon">
            {company?.image == "" || company?.image == null ? (
              <img
                src={paths.SITE_BASE_URL + "/images/no-image.svg"}
                alt="no image found"
              />
            ) : (
              <ImageControl
                src={company?.image}
                folder="companies"
                isThumb={true}
              />
            )}
            {/* <img src={company.logo} alt={company.name} /> */}
          </div>

          <div className="text">
            <div className="heading h4 m-0">
              <Link to="#">{company?.name}</Link>

              {/* {sponsorType && sponsorConfig[sponsorType] && (
                <div
                  className={`sponsor_tag ${sponsorConfig[sponsorType].className}`}
                >
                  <img
                    src={sponsorConfig[sponsorType].icon}
                    alt={sponsorConfig[sponsorType].label}
                  />
                  {sponsorConfig[sponsorType].label}
                </div>
              )} */}

              {company?.sponsorType}

              {company?.verified && (
                <div className="verified_badge">Verified</div>
              )}
            </div>

            <p>{company?.description}</p>

            <ul className="mini_list">
              <li>
                <img
                  src={paths.SITE_BASE_URL + "/images/icon_mini_map_marker.png"}
                  alt=""
                />
                {company?.location}
              </li>
              <li>
                <img
                  src={paths.SITE_BASE_URL + "/images/icon_mini_group.png"}
                  alt=""
                />
                {company?.employees}
              </li>
              <li>
                <img
                  src={paths.SITE_BASE_URL + "/images/icon_mini_calendar.png"}
                  alt=""
                />
                Founded in {company?.founded}
              </li>
              <li>
                <img
                  src={paths.SITE_BASE_URL + "/images/icon_mini_internet.png"}
                  alt=""
                />
                <a href={company?.website} target="_blank" rel="noreferrer">
                  {company?.website}
                </a>
              </li>
            </ul>

            <div className="btn_blk">
              <Link
                type="button"
                className="site_btn"
                onClick={() =>
                  document.getElementById("jobs-section")?.scrollIntoView({
                    behavior: "smooth",
                  })
                }
              >
                <img
                  src={paths.SITE_BASE_URL + "/images/icon_mini_briefcase.png"}
                  alt=""
                />
                View All Jobs ({company?.totalJobs})
              </Link>

              {/* <button type="button" className="site_btn blank">
                <img
                  src={paths.SITE_BASE_URL + "/images/icon_mini_bookmark.png"}
                  alt=""
                />
                Follow Company
              </button> */}

              {/* <button
                type="button"
                className="site_btn blank dark"
                onClick={() => setShowShare(!showShare)}
              >
                <img
                  src={paths.SITE_BASE_URL + "/images/icon_mini_share.png"}
                  alt=""
                />
                Share
              </button> */}
              {/* Show social icons when share button clicked */}
              {showShare && (
                <div
                  className="share_icons"
                  style={{
                    display: "flex",
                    gap: "10px",
                    // marginTop: "3px",
                    padding: "7px 10px", // optional for spacing
                    backgroundColor: "#dbeafe", // light transparent background
                    borderRadius: "8px", // optional, makes it look nicer
                    backdropFilter: "blur(5px)",
                  }}
                >
                  {socialLinks.map((link) => (
                    <a
                      key={link.name}
                      href={link.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      title={`Share on ${link.name}`}
                    >
                      <img
                        src={link.icon}
                        alt={link.name}
                        width={32}
                        height={32}
                      />
                    </a>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
